import { getCalendarFolder, getCalendarIdByFolderId } from 'owa-calendar-cache';

/**
 * Gets calendar charm scheme by folder id
 * @returns the charm for the calendar
 */
export function getCalendarCharmIdByFolderId(calendarFolderId: string): number {
    let calendarId = getCalendarIdByFolderId(calendarFolderId);
    let calendarFolder = calendarId && getCalendarFolder({ id: calendarId });
    if (calendarFolder) {
        return calendarFolder.CharmId;
    } else {
        return null;
    }
}
